// Mobile product gallery.
//
// This was Flickity: ~85KB of JS plus a render-blocking stylesheet, both from
// unpkg.com — a third-party origin sitting on the critical path of every
// product and collection page — to provide one horizontally swipeable strip.
//
// CSS scroll-snap does the same job natively. The browser owns the drag, the
// momentum and the snap, so nothing runs on the main thread while the visitor
// swipes, which is where Flickity's cost landed: it binds pointer handlers and
// writes transforms on every pointermove. What is left here only reflects which
// cell is showing, to drive the dots.
//
// Flickity's lazyLoad:2 was already doing nothing — it only acts on
// img[data-flickity-lazyload], and this markup has never used that attribute.
// The loading/fetchpriority hints in the section are what actually stage these
// images, and they are unaffected.
//
// Video playback is deliberately not handled here any more. The
// IntersectionObserver below already plays and pauses every
// .video-thumbnail-container video on visibility, and a cell scrolled out of a
// horizontal overflow container genuinely does not intersect the viewport, so
// it covers this gallery for free. The old Flickity "change" handler was
// duplicating that work.
document.addEventListener("DOMContentLoaded", function () {
  const gallery = document.querySelector(".mobile-product-gallery");
  if (!gallery) return;

  const cells = Array.from(gallery.children);
  if (cells.length === 0) return;

  let dots = [];

  // Dots belong to the wrapper, not the scroller. An absolutely positioned
  // child of a scroll container still scrolls with its content, so dots placed
  // inside the gallery would slide off screen along with the images.
  const wrapper = gallery.parentElement;
  if (wrapper && cells.length > 1) {
    const dotList = document.createElement("div");
    dotList.className = "product-gallery-dots";

    dots = cells.map(function (cell, index) {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "product-gallery-dot";
      dot.setAttribute("aria-label", "Go to image " + (index + 1));
      dot.addEventListener("click", function () {
        // Not scrollIntoView: it resolves the block axis too and can jerk the
        // page vertically on the way to a horizontal target.
        gallery.scrollTo({
          left: cell.offsetLeft - cells[0].offsetLeft,
          behavior: "smooth",
        });
      });
      dotList.appendChild(dot);
      return dot;
    });

    wrapper.appendChild(dotList);
  }

  let active = -1;
  function setActive(index) {
    if (index === active) return;
    active = index;
    cells.forEach(function (cell, i) {
      cell.classList.toggle("is-selected", i === index);
    });
    dots.forEach(function (dot, i) {
      dot.classList.toggle("is-active", i === index);
      dot.setAttribute("aria-current", i === index ? "true" : "false");
    });
  }

  // Most-visible cell wins. The observer only reports entries whose ratio
  // changed, so every cell's last known ratio is kept and the whole set is
  // compared on each callback — otherwise a cell that simply stopped changing
  // would be read as invisible and the wrong dot would light up.
  const ratios = new Map();
  const cellObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        ratios.set(entry.target, entry.intersectionRatio);
      });

      let best = 0;
      let bestRatio = -1;
      cells.forEach(function (cell, i) {
        const ratio = ratios.get(cell) || 0;
        if (ratio > bestRatio) {
          bestRatio = ratio;
          best = i;
        }
      });
      setActive(best);
    },
    { root: gallery, threshold: [0, 0.25, 0.5, 0.75, 1] },
  );

  cells.forEach(function (cell) {
    cellObserver.observe(cell);
  });
});

// Add intersection observer to play videos when they come into view
document.addEventListener("DOMContentLoaded", function () {
  const videoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          // Video is in view, play it
          video.play().catch((e) => {
            console.log("Video autoplay failed:", e);
          });
        } else {
          video.pause();
        }
      });
    },
    {
      threshold: 0.5, // Play when 50% of video is visible
    },
  );

  const videoThumbnails = document.querySelectorAll(
    ".video-thumbnail-container video",
  );
  videoThumbnails.forEach((video) => {
    videoObserver.observe(video);
  });
});

// Reviews API integration
(function () {
  let reviewBtn = document.querySelector(".write_review");
  if (reviewBtn) {
    reviewBtn.addEventListener("click", (e) => {
      document.querySelector(".ruk-rating-snippet-count").click();
      document.querySelector("#reviews_fade .R-Button").click();
    });
  }
})();

// Main gallery functionality
document.addEventListener("DOMContentLoaded", function () {
  const mainMediaContainer = document.getElementById("mainMediaContainer");
  const thumbnails = document.querySelectorAll(".thumbnail");

  let prevThumb = null;
  let nextThumb = null;

  function updateGalleryStatus() {
    // Guarded because this now runs on every image click in imagery-grid mode,
    // where it previously only ran once on load. An unguarded throw here would
    // abort the click handler and leave the gallery dead for the rest of the
    // session. Nothing here is essential — it only enables/disables the
    // prev/next arrows, which are display:none above 960px anyway.
    let selectedThumb = document.querySelector(".thumbnail.active");
    if (!selectedThumb) return;

    prevThumb = selectedThumb.previousElementSibling;
    nextThumb = selectedThumb.nextElementSibling;

    // Disable/Enable arrows
    if (prevArrow) {
      prevArrow.disabled =
        !prevThumb || !prevThumb.classList.contains("thumbnail");
    }
    if (nextArrow) {
      nextArrow.disabled =
        !nextThumb || !nextThumb.classList.contains("thumbnail");
    }
  }

  function loadNextMedia(thumbnail) {
    const mediaType = thumbnail.getAttribute("data-media-type");
    // data-main-src is sized for the main slot (~785 CSS px at most, 1600w to
    // cover 2x). data-src is the 2000w file the zoom modal needs for its 5x
    // scale, and is the fallback for video thumbnails, which have no
    // data-main-src because the <source> url is not resizable.
    const nextMediaSrc =
      thumbnail.getAttribute("data-main-src") ||
      thumbnail.getAttribute("data-src");

    // Remove the current main media element
    mainMediaContainer.innerHTML = "";

    // Create and append the new main media element
    const mainMediaElement = createMediaElement(mediaType, nextMediaSrc);
    mainMediaContainer.appendChild(mainMediaElement);

    // Remove active class from all thumbnails and add it to the clicked one
    thumbnails.forEach((thumb) => {
      thumb.classList.remove("active");
    });
    thumbnail.classList.add("active");
    // Only scroll into view if not in grid mode
    if (!document.querySelector(".carousel-thumbnails.imagery-grid")) {
      thumbnail.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    }
  }

  function createMediaElement(mediaType, src) {
    if (mediaType === "image") {
      const image = document.createElement("img");
      image.src = src;
      image.alt = "Main Image";
      return image;
    } else if (mediaType === "video") {
      const video = document.createElement("video");
      video.src = src;
      video.controls = true;
      video.autoplay = false;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      return video;
    }
    return null;
  }

  let prevArrow = document.querySelector(".product-gallery-prev");
  let nextArrow = document.querySelector(".product-gallery-next");

  if (prevArrow) {
    prevArrow.addEventListener("click", () => {
      console.log("clicked prev");
      if (prevThumb) {
        loadNextMedia(prevThumb);
        updateGalleryStatus();
      }
    });
  }

  if (nextArrow) {
    nextArrow.addEventListener("click", () => {
      console.log("clicked next");
      if (nextThumb) {
        loadNextMedia(nextThumb);
        updateGalleryStatus();
      }
    });
  }

  // Set the main image or video to the first thumbnail on page load (skip when imagery grid - first image already in main from Liquid)
  const isImageryGridOnLoad = document.querySelector(
    ".carousel-thumbnails.imagery-grid",
  );
  // The section now renders the initial main image server-side so it is the
  // LCP element in the initial HTML rather than something this script appends
  // at DOMContentLoaded. When that element is present there is nothing to
  // build — appending anyway would stack a second, identical image.
  const existingMainMedia =
    mainMediaContainer &&
    mainMediaContainer.querySelector("[data-server-rendered-main]");

  if (thumbnails.length > 0 && !isImageryGridOnLoad) {
    // Find the first active thumbnail (set by Liquid template)
    const firstThumbnail =
      document.querySelector(".thumbnail.active") || thumbnails[0];

    if (!existingMainMedia) {
      const mediaType = firstThumbnail.getAttribute("data-media-type");
      const mainMediaElement = createMediaElement(
        mediaType,
        firstThumbnail.getAttribute("data-src"),
      );
      if (mainMediaElement && mainMediaContainer) {
        mainMediaContainer.appendChild(mainMediaElement);
      }
    }
    firstThumbnail.classList.add("active"); // Add active class to the first thumbnail

    // Initial status update
    updateGalleryStatus();
  } else if (thumbnails.length > 0 && isImageryGridOnLoad) {
    updateGalleryStatus();
  }

  // Videos now auto-play, simplified click handlers for images only
  const carouselThumbnails = document.querySelector(".carousel-thumbnails");
  if (carouselThumbnails) {
    carouselThumbnails.addEventListener("click", function (e) {
      const thumbnail = e.target.closest(".thumbnail");
      const videoContainer = e.target.closest(".video-thumbnail-container");
      if (!thumbnail && !videoContainer) return;

      e.preventDefault();
      e.stopPropagation();

      // Check if it's a video container or regular thumbnail
      const targetElement = videoContainer || thumbnail;
      const mediaType = targetElement.getAttribute("data-media-type");

      // Handle both images and videos
      if (mediaType === "image") {
        // Imagery grid mode used to be special-cased here: clicking an image
        // only moved the .active class and deliberately left the main image
        // alone. Clicking a *video* had no such check and always swapped the
        // main area, so on a grid PDP — which is what templates/product.json
        // runs — the gallery looked broken: videos responded to clicks and
        // images did nothing. Both media types now swap the main image.
        //
        // loadNextMedia is safe in grid mode: it already skips its
        // scrollIntoView call when .carousel-thumbnails.imagery-grid is
        // present, which is the one thing that behaved badly in a grid.
        loadNextMedia(thumbnail);
        updateGalleryStatus();
      } else if (mediaType === "video") {
        // For videos, load the video in the main media area
        const videoSrc = targetElement.getAttribute("data-src");
        console.log("Video clicked, src:", videoSrc);
        if (videoSrc) {
          const mainMedia = document.getElementById("mainMediaContainer");
          console.log("Main media found:", mainMedia);
          if (mainMedia) {
            const videoElement = document.createElement("video");
            videoElement.src = videoSrc;
            videoElement.controls = true;
            videoElement.autoplay = false;
            videoElement.muted = true;
            videoElement.loop = true;
            videoElement.playsInline = true;
            videoElement.style.width = "100%";
            videoElement.style.height = "100%";
            videoElement.style.objectFit = "cover";

            mainMedia.innerHTML = "";
            mainMedia.appendChild(videoElement);
            console.log("Video element added to main media");
          }
        }
      }
    });
  }

  // Add double-click support for video containers to open in zoom modal
  if (carouselThumbnails) {
    carouselThumbnails.addEventListener("dblclick", function (e) {
      const videoContainer = e.target.closest(".video-thumbnail-container");
      console.log("Double-click detected, video container:", videoContainer);
      if (videoContainer) {
        const videoSrc = videoContainer.getAttribute("data-src");
        const mediaType = videoContainer.getAttribute("data-media-type");
        console.log("Video src:", videoSrc, "Media type:", mediaType);

        if (videoSrc && mediaType === "video") {
          // Trigger zoom modal
          console.log("Zoom modal available:", window.zoomModal);
          if (window.zoomModal) {
            window.zoomModal.openModal(videoSrc, "Video", "video");
          } else {
            console.log("Zoom modal not available, trying to initialize...");
            // Try to initialize zoom modal
            if (typeof ZoomModal !== "undefined") {
              window.zoomModal = new ZoomModal();
              window.zoomModal.openModal(videoSrc, "Video", "video");
            }
          }
        }
      }
    });
  }

  // Also add direct double-click listeners to video containers as fallback
  const videoContainers = document.querySelectorAll(
    ".video-thumbnail-container",
  );
  videoContainers.forEach((container) => {
    container.addEventListener("dblclick", function (e) {
      e.preventDefault();
      e.stopPropagation();
      const videoSrc = this.getAttribute("data-src");
      const mediaType = this.getAttribute("data-media-type");
      console.log(
        "Direct double-click on video container:",
        videoSrc,
        mediaType,
      );

      if (videoSrc && mediaType === "video") {
        if (window.zoomModal) {
          window.zoomModal.openModal(videoSrc, "Video", "video");
        } else if (typeof ZoomModal !== "undefined") {
          window.zoomModal = new ZoomModal();
          window.zoomModal.openModal(videoSrc, "Video", "video");
        }
      }
    });
  });

});

// Initialize zoom modal with delay to ensure script is loaded
if (typeof ZoomModal !== "undefined") {
  window.zoomModal = new ZoomModal();
  console.log("Zoom modal initialized");
} else {
  console.log("ZoomModal class not found");
}

// Button container functionality (for any button containers on the page)
document.addEventListener("DOMContentLoaded", function () {
  const btnContainer = document.querySelector(".btn-container");
  if (btnContainer) {
    var btns = btnContainer.getElementsByClassName("btn");

    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener("click", function () {
        // Remove "active" class from any button that has it
        var activeBtn = btnContainer.querySelector(".active");
        if (activeBtn) {
          activeBtn.classList.remove("active");
        }

        // Add "active" class to the clicked button
        this.classList.add("active");
      });
    }
  }
});

// Subscription-only text block visibility toggle
document.addEventListener("DOMContentLoaded", function () {
  var subscriptionBlocks = document.querySelectorAll(
    "[data-subscription-only]",
  );
  if (subscriptionBlocks.length === 0) return;

  function toggleSubscriptionBlocks(activeTab) {
    subscriptionBlocks.forEach(function (block) {
      block.style.display = activeTab === "subscribe" ? "" : "none";
    });
  }

  // Listen for tab changes on each tabbed product block element
  var tabbedBlocks = document.querySelectorAll("tabbed-product-block");
  tabbedBlocks.forEach(function (tabbedBlock) {
    tabbedBlock.addEventListener("tabChanged", function (e) {
      if (e.detail && e.detail.activeTab) {
        toggleSubscriptionBlocks(e.detail.activeTab);
      }
    });

    // Check initial state — if subscribe tab is already active, show the blocks
    if (typeof tabbedBlock.getActiveTab === "function") {
      toggleSubscriptionBlocks(tabbedBlock.getActiveTab());
    }
  });
});
